module.exports = __webpack_public_path__ + "img/xml.b3e1953d.svg";